
/* ================= SHOP SETTINGS ================= */
const CONFIG = {
  title: "GHOSTELLE™ – Ghost Dress",
  price: 39.99,           // shown until your Shopify costume product exists; then Shopify's price is used
  sizes: ["S", "M"],          // available sizes (once Shopify is linked, the sizes come from the product variants)
  defaultSize: "M",       // preselected size
  bestPick: "M",          // size with the glowing "Best pick" sign ("" = none)
  bestPickLabel: "Best pick",   // text on the fire tag at M (only write "Most bought" once your sales data shows it)
  // Quantity offers. "code" must exist in Shopify (Discounts) with the same % and minimum quantity.
  bundles: [
    { qty: 1, title: "Buy 1", note: "Regular price" },
    { qty: 2, title: "Buy 2, save 10%", off: 10, tag: "Ghost & bestie", note: "Matching looks for you and your best friend.", code: "GHOSTDUO10" },
    { qty: 3, title: "Buy 3, save 20%", off: 20, tag: "Ghost squad", note: "The whole squad haunts together.", code: "GHOSTSQUAD20", badge: "Best value" },
  ],
  saleEndsAt: null,       // real sale end, e.g. "2026-10-31T23:59:00+01:00" – bar hides at zero
  saleText: "Halloween sale ends in",
  offerText: null,        // e.g. "20% off – Halloween sale 🎃" (only with a real sale)
  shippingText: "Free shipping worldwide 🌍",
  returnsText: "30-day returns",
  // Size chart (shown behind "Size guide" once filled in), e.g.
  // { size: "S", chest: "82–86 cm", waist: "64–68 cm", hips: "88–92 cm" }
  sizeChart: [],
  faq: [
    { q: "Which size should I pick?", a: "Pick your usual size. The dress is made to sit close to the body." },
    { q: "How do I wash it?", a: "Hand wash, do not bleach, do not tumble dry, iron on low heat." },
    { q: "Shipping and returns?", a: "Free shipping worldwide. You can return your order within 30 days." },
  ],
  tiktokUrl: "",          // your TikTok profile, e.g. "https://www.tiktok.com/@ghostelle"
  tiktokShopUrl: "",      // optional: link to this product in your TikTok Shop
  lowStockAt: 15,         // "only X left" shows below this number (uses real Shopify inventory)
  rating: null,           // real data only, e.g. { value: 4.8, count: 214 }
  // REAL reviews only. verified: true only for confirmed buyers.
  // e.g. { quote: "My cat was the star of the night.", name: "Anna K.", stars: 5, verified: true }
  reviews: [],
  // REAL customer photos (with permission): { img: "url", title: "...", quote: "...", name: "...", stars: 5 }
  spotlight: [],
  // Until real reviews exist, these fill the two sections. No names, no stars.
  bandLines: ["Haunt the night 👻", "Boo-tiful 🤍", "Ghost mode: on 🕯️", "Main character of the party", "Trick or treat? 🎃"],
  photoCaptions: [
    { title: "Front", text: "Ghost hood with eyes and blush cheeks." },
    { title: "Side", text: "Figure-hugging mermaid silhouette." },
    { title: "Back", text: "Long sleeves and a floor-length train." },
  ],
  socialImages: [],       // real TikTok comments / customer photos (image URLs)
};
/* ================================================= */

const DATA = JSON.parse(document.getElementById("page-data").textContent);
const PHOTOS = DATA.images;
const LIFE = DATA.life;
const REVIEW_PHOTOS = DATA.reviewPhotos;
const LINKED = DATA.variants.length > 0;   // true when the Shopify costume product was found
const VARIANTS = LINKED ? DATA.variants
  : CONFIG.sizes.map(s => ({ id: null, size: s, available: true, price: Math.round(CONFIG.price * 100), compareAt: 0, stock: null }));
const SIZES = VARIANTS.map(v => v.size);
const variantOf = s => VARIANTS.find(v => v.size === s);
const MAX = 10;
const $ = id => document.getElementById(id);
const euro = n => "€" + n.toFixed(2).replace(".", ",");
const HICONS = ['<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M11.2 6.2c-.2-1.5.4-2.6 1.7-3.1l.5.9c-.8.4-1.1 1.1-1 2.2ZM12 6.5c-1.3-.6-2.7-.7-4-.3C5.1 7 3 9.6 3 13.4 3 17.8 6.4 21 10 21c.8 0 1.4-.2 2-.4.6.2 1.2.4 2 .4 3.6 0 7-3.2 7-7.6 0-3.8-2.1-6.4-5-7.2-1.3-.4-2.7-.3-4 .3ZM7.6 12.6l1.9-2.4 1.9 2.4ZM12.6 12.6l1.9-2.4 1.9 2.4ZM7.8 15.2c1.3 1.2 2.7 1.8 4.2 1.8s2.9-.6 4.2-1.8l-.8 2.1-1.4-.9-2 1.3-2-1.3-1.4.9Z"/></svg>', '<svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="M9 11.5 5 9.5 3 11M9 13.5 4.5 13 2.5 15M9.3 15.5 5.5 17.5 4.5 20M10 17 8 20.5M15 11.5l4-2 2 1.5M15 13.5l4.5-.5 2 2M14.7 15.5l3.8 2 1 2.5M14 17l2 3.5"/></g><ellipse cx="12" cy="14" rx="3.2" ry="3.8" fill="currentColor"/><circle cx="12" cy="9.4" r="2.1" fill="currentColor"/></svg>', '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 9.5c-.6-1-1.3-1.5-1.3-1.5l-.4 1.6C8 8 5 9 2 12c2-.3 3.3.3 4 1.5.8-.8 2-1 3 .2.9-.6 1.9-.6 3 .8 1.1-1.4 2.1-1.4 3-.8 1-1.2 2.2-1 3-.2.7-1.2 2-1.8 4-1.5-3-3-6-4-8.3-2.4l-.4-1.6s-.7.5-1.3 1.5Z"/></svg>'];
const noEmoji = t => String(t).replace(/[\p{Extended_Pictographic}\uFE0F\u200D]/gu, "").replace(/\s{2,}/g, " ").trim();
const esc = s => String(s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const NAME = CONFIG.title;
const money = c => euro(c / 100);
const PAY = document.getElementById("payIcons").innerHTML.trim();

/* Images set from JS (keeps the file small) */
$("lifeImg").src = LIFE; $("bagImg").src = DATA.bag; if (PHOTOS[0]) $("stickyImg").src = PHOTOS[0].thumb;

/* Text */
$("title").textContent = NAME;
$("promise1").textContent = CONFIG.shippingText.replace(/\s*\p{Extended_Pictographic}/gu, "");
$("promise2").textContent = CONFIG.returnsText;
$("stickyName").textContent = NAME;
$("year").textContent = new Date().getFullYear();
$("infoText").textContent = CONFIG.shippingText.replace(/\s*\p{Extended_Pictographic}/gu, "") + ". You can return your order within 30 days. Taxes and shipping options are shown at checkout.";

/* 1. Sale countdown – only for a real sale, never restarts */
if (CONFIG.saleEndsAt) {
  const end = new Date(CONFIG.saleEndsAt).getTime(), bar = $("saleBar");
  $("saleText").textContent = CONFIG.saleText; $("saleShip").textContent = CONFIG.shippingText;
  const pad = n => String(n).padStart(2, "0");
  const tick = () => {
    const left = end - Date.now();
    if (left <= 0) { bar.hidden = true; clearInterval(timer); return; }
    bar.hidden = false;
    $("cdD").textContent = pad(Math.floor(left / 864e5)); $("cdH").textContent = pad(Math.floor(left / 36e5) % 24);
    $("cdM").textContent = pad(Math.floor(left / 6e4) % 60); $("cdS").textContent = pad(Math.floor(left / 1e3) % 60);
  };
  const timer = setInterval(tick, 1000); tick();
}

/* 2 + 7. Marquees */
(function () {
  const items = [CONFIG.offerText, CONFIG.shippingText, CONFIG.returnsText + " 🕯️", "Haunt the night 👻"].filter(Boolean);
  const row = hidden => "<ul" + (hidden ? ' aria-hidden="true"' : "") + ">" + [...items, ...items, ...items].map((t, i) => "<li>" + esc(noEmoji(t)) + '<span class="sep">' + HICONS[i % 3] + "</span></li>").join("") + "</ul>";
  $("bar1").innerHTML = '<div class="track">' + row(false) + row(true) + "</div>";
  $("bar2").innerHTML = '<div class="track">' + row(true) + row(true) + "</div>";
})();

/* Menu + footer links (email and policies from Shopify settings) */
(function () {
  const links = [["#shop", "Shop"], ["#info", "Shipping & returns"]];
  if (DATA.email) links.push(["mailto:" + DATA.email, "Contact"]);
  if (CONFIG.tiktokUrl) links.push([CONFIG.tiktokUrl, "TikTok"]);
  $("menuLinks").innerHTML = links.map(([h, t]) => '<a href="' + esc(h) + '">' + esc(t) + "</a>").join("");
  const foot = [...(DATA.email ? [["mailto:" + DATA.email, "Contact"]] : []), ...(CONFIG.tiktokUrl ? [[CONFIG.tiktokUrl, "TikTok"]] : []), ...DATA.policies.map(p => [p.url, p.title])];
  $("footLinks").innerHTML = foot.map(([h, t]) => '<a href="' + esc(h) + '">' + esc(t) + "</a>").join("");
  if (PAY) { $("footPay").innerHTML = PAY; $("footPay").hidden = false; }
})();

/* 5. Gallery + lightbox */
(function () {
  const slides = $("slides"), thumbs = $("thumbs"), track = $("lbTrack");
  slides.innerHTML = PHOTOS.map((p, i) => '<button type="button" class="slide' + (p.contain ? " contain" : "") + '" data-i="' + i + '" aria-label="Enlarge photo ' + (i + 1) + '"><img src="' + p.src + '" alt="' + esc(p.alt) + '"' + (i ? ' loading="lazy"' : "") + "></button>").join("");
  thumbs.innerHTML = PHOTOS.map((p, i) => '<button type="button" class="thumb" aria-label="Show photo ' + (i + 1) + '" aria-current="' + (i === 0) + '"><img src="' + (p.thumb || p.src) + '" alt=""></button>').join("");
  track.innerHTML = PHOTOS.map(p => '<img src="' + p.src + '" alt="' + esc(p.alt) + '" loading="lazy">').join("");
  const tb = [...thumbs.children], mark = i => tb.forEach((b, j) => b.setAttribute("aria-current", i === j));
  tb.forEach((b, i) => b.onclick = () => { slides.scrollTo({ left: i * slides.clientWidth, behavior: "smooth" }); mark(i); });
  slides.addEventListener("scroll", () => mark(Math.round(slides.scrollLeft / slides.clientWidth)), { passive: true });

  const lb = $("lightbox");
  const lbIndex = () => Math.round(track.scrollLeft / track.clientWidth);
  const count = () => { $("lbCount").textContent = (lbIndex() + 1) + " / " + PHOTOS.length; };
  const go = i => { track.scrollTo({ left: Math.max(0, Math.min(PHOTOS.length - 1, i)) * track.clientWidth }); count(); };
  slides.addEventListener("click", e => {
    const s = e.target.closest(".slide"); if (!s) return;
    lb.classList.add("open"); lb.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden";
    requestAnimationFrame(() => { go(+s.dataset.i); $("lbClose").focus(); });
  });
  const close = () => { lb.classList.remove("open"); lb.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; };
  $("lbClose").onclick = close;
  $("lbPrev").onclick = () => go(lbIndex() - 1); $("lbNext").onclick = () => go(lbIndex() + 1);
  track.addEventListener("scroll", count, { passive: true });
  document.addEventListener("keydown", e => {
    if (!lb.classList.contains("open")) return;
    if (e.key === "Escape") close(); if (e.key === "ArrowRight") go(lbIndex() + 1); if (e.key === "ArrowLeft") go(lbIndex() - 1);
  });
})();

/* Rating + stock (real data only) */
if (CONFIG.rating) {
  const star = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 3.6 2.6 5.2 5.7.8-4.1 4 1 5.7-5.2-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8Z"/></svg>';
  $("rating").innerHTML = star + "<span>Rated <b>" + String(CONFIG.rating.value).replace(".", ",") + "</b> (" + CONFIG.rating.count + ") happy customers</span>";
  $("rating").hidden = false;
}

/* Offers (Buy 1/2/3), sizes per dress, price, stock */
const firstAvailable = (VARIANTS.find(v => v.available) || VARIANTS[0] || {}).size;
let size = variantOf(CONFIG.defaultSize) && variantOf(CONFIG.defaultSize).available ? CONFIG.defaultSize : firstAvailable;
let bundle = 1;
const sizes = [size, size, size, size, size];
const offerOf = n => CONFIG.bundles.find(b => b.qty === n) || { qty: n, off: 0 };
const discountFor = count => CONFIG.bundles.filter(b => b.off && b.qty <= count).reduce((best, b) => (b.off > best.off ? b : best), { off: 0 });
const pctOff = (cents, pct) => Math.round(cents * (100 - (pct || 0)) / 100);
const unit = s => (variantOf(s) || {}).price || 0;
const regularTotal = n => sizes.slice(0, n).reduce((t, s) => t + unit(s), 0);
const bundleTotal = n => pctOff(regularTotal(n), offerOf(n).off);
const CROWN = '<svg class="crown" viewBox="0 0 24 16" fill="currentColor" aria-hidden="true"><path d="M2 15h20l-1.6-10-5 4.2L12 1 8.6 9.2l-5-4.2z"/><circle cx="3.6" cy="4.6" r="1.6"/><circle cx="12" cy="1.6" r="1.6"/><circle cx="20.4" cy="4.6" r="1.6"/></svg>';
const GHOST_BADGE = '<svg class="ghost" viewBox="0 0 24 24" aria-hidden="true"><path fill="#F7F2EA" d="M12 2.5a7.5 7.5 0 0 0-7.5 7.5v11l2.5-1.7 2.5 1.7 2.5-1.7 2.5 1.7 2.5-1.7 2.5 1.7V10A7.5 7.5 0 0 0 12 2.5Z"/><ellipse cx="9.3" cy="10" rx="1.3" ry="1.8" fill="#120C12"/><ellipse cx="14.7" cy="10" rx="1.3" ry="1.8" fill="#120C12"/></svg>';
const FLAME = '<svg class="flame" viewBox="0 0 24 32" aria-hidden="true"><path d="M12 1c1 5 7 8 7 16a7 7 0 0 1-14 0c0-4 2-6 3-8 .5 2 1.5 3 3 3-1-4 0-8 1-11Z" fill="#FF5A14"/><path class="fi" d="M12 12c.7 3.2 4.3 4.8 4.3 9a4.3 4.3 0 0 1-8.6 0c0-2.4 1.3-3.9 2.2-5 .3 1.3 1.1 2 2 2-.6-2.4 0-4.5.1-6Z" fill="#FFB02E"/><path class="fi" d="M12 20c.4 1.6 2.2 2.4 2.2 4.5a2.2 2.2 0 0 1-4.4 0c0-1.2.7-2 1.1-2.5.2.6.6 1 1 1-.3-1.2 0-2.2.1-3Z" fill="#FFF1B8"/></svg>';
const GHOST_MINI = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2.5a7.5 7.5 0 0 0-7.5 7.5v11l2.5-1.7 2.5 1.7 2.5-1.7 2.5 1.7 2.5-1.7 2.5 1.7V10A7.5 7.5 0 0 0 12 2.5Z"/><ellipse cx="9.3" cy="10" rx="1.3" ry="1.8" fill="#120C12"/><ellipse cx="14.7" cy="10" rx="1.3" ry="1.8" fill="#120C12"/></svg>';

function sizeOptions(row) {
  return VARIANTS.map(x => '<option value="' + esc(x.size) + '"' + (x.size === sizes[row] ? " selected" : "") + (x.available ? "" : " disabled") + ">" +
    esc(x.size) + (x.size === CONFIG.bestPick && sizes[row] !== CONFIG.bestPick ? " – " + CONFIG.bestPickLabel.toLowerCase() + " 🔥" : "") + (x.available ? "" : " – sold out") + "</option>").join("");
}

function renderOffers() {
  // thumbnails per offer: Buy 1 = solo photo, Buy 2 = the two women from the duo photo, Buy 3 = the three from the trio photo
  const OT = DATA.offerThumbs || {};
  const thumbsFor = qty => OT[qty] || OT[Object.keys(OT).filter(k => +k <= qty).sort((a, b) => b - a)[0]] || [PHOTOS[0] ? PHOTOS[0].thumb : ""];
  $("offers").innerHTML = CONFIG.bundles.map(b => {
    const on = b.qty === bundle, reg = regularTotal(b.qty), tot = bundleTotal(b.qty);
    let rows = "";
    if (on) {
      for (let r = 0; r < b.qty; r++) {
        rows += '<div class="o-row"><img src="' + thumbsFor(b.qty)[r % thumbsFor(b.qty).length] + '" alt="">' +
          '<label class="sr-only" for="size-' + r + '">Size' + (b.qty > 1 ? " for dress " + (r + 1) : "") + (sizes[r] === CONFIG.bestPick ? ", " + esc(CONFIG.bestPickLabel.toLowerCase()) : "") + "</label>" +
          '<div class="sel' + (sizes[r] === CONFIG.bestPick ? " hot" : "") + '"><select id="size-' + r + '" data-row="' + r + '">' + sizeOptions(r) + "</select>" +
          (sizes[r] === CONFIG.bestPick ? '<span class="fire-tag" aria-hidden="true">' + FLAME + esc(CONFIG.bestPickLabel) + "</span>" : "") + "</div></div>";
      }
    }
    return '<div class="offer' + (on ? " on" : "") + (b.badge ? " has-badge" : "") + '" role="radio" tabindex="' + (on ? 0 : -1) + '" aria-checked="' + on + '" data-qty="' + b.qty + '" aria-label="' + esc(b.title + ", " + money(tot)) + '">' +
      (b.badge ? '<span class="pick offer-pick" aria-hidden="true">' + CROWN + esc(b.badge) + GHOST_BADGE + "</span>" : "") +
      '<div class="o-head"><span class="radio" aria-hidden="true"></span>' +
      '<span class="o-main"><span class="o-title">' + esc(b.title) + '<span class="o-ghosts" aria-hidden="true">' + GHOST_MINI.repeat(b.qty) + "</span></span>" +
      (b.tag ? '<span class="o-tag">' + esc(b.tag) + "</span>" : "") +
      '<span class="o-note">' + esc(b.note) + "</span></span>" +
      '<span class="o-price"><strong>' + money(tot) + "</strong>" +
      (b.off ? "<s>" + money(reg) + "</s><small>" + money(Math.round(tot / b.qty)) + " each</small>" : "") + "</span></div>" +
      (on ? '<div class="o-sizes"><span class="o-sizes-label">' + (b.qty > 1 ? "Pick a size for each dress" : "Pick your size") + "</span>" + rows + "</div>" : "") +
      "</div>";
  }).join("");
}

function renderAll() {
  size = sizes[0];
  renderOffers();
  const o = offerOf(bundle), reg = regularTotal(bundle), tot = bundleTotal(bundle), v = variantOf(size) || {};
  $("price").textContent = money(tot);
  const cmp = o.off ? reg : (v.compareAt && v.compareAt > v.price ? v.compareAt : 0);
  $("compare").hidden = !cmp; if (cmp) $("compare").textContent = money(cmp);
  $("each").hidden = bundle < 2; if (bundle > 1) $("each").textContent = money(Math.round(tot / bundle)) + " each, you save " + money(reg - tot);
  const lowSize = sizes.slice(0, bundle).find(s => { const x = variantOf(s) || {}; return typeof x.stock === "number" && x.stock > 0 && x.stock < CONFIG.lowStockAt; });
  $("stock").hidden = !lowSize; if (lowSize) $("stock").innerHTML = "🔥 Selling fast – only <b>" + variantOf(lowSize).stock + " left</b> in size " + esc(lowSize);
  const soldOut = sizes.slice(0, bundle).some(s => !(variantOf(s) || {}).available);
  const label = soldOut ? "Sold out" : "Take the offer – " + money(tot);
  $("addLabel").textContent = label;
  ["addBtn", "stickyBtn", "lifeBtn"].forEach(id => { $(id).disabled = soldOut; });
  $("lifeBtn").textContent = label;
  $("stickyMeta").textContent = (bundle > 1 ? "Buy " + bundle + ", " : "Size " + size + ", ") + money(tot);
}
function pickOffer(qty, focus) {
  if (qty === bundle) return;
  bundle = qty; renderAll();
  if (focus) { const el = document.querySelector('.offer[data-qty="' + qty + '"]'); if (el) el.focus(); }
}
$("offers").addEventListener("click", e => {
  if (e.target.closest("select, label, .o-sizes")) return;          // picking a size never switches the offer
  const card = e.target.closest("[data-qty]"); if (card) pickOffer(+card.dataset.qty, false);
});
$("offers").addEventListener("change", e => {
  const sel = e.target.closest("select[data-row]"); if (!sel) return;
  sizes[+sel.dataset.row] = sel.value; renderAll();
  const again = $("size-" + sel.dataset.row); if (again) again.focus();
});
$("offers").addEventListener("keydown", e => {
  const card = e.target.closest(".offer"); if (!card || e.target !== card) return;
  const qtys = CONFIG.bundles.map(b => b.qty), i = qtys.indexOf(+card.dataset.qty);
  if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pickOffer(+card.dataset.qty, true); }
  if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); pickOffer(qtys[(i + 1) % qtys.length], true); }
  if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); pickOffer(qtys[(i - 1 + qtys.length) % qtys.length], true); }
});
renderAll();

/* 6. Image slider */
(function () {
  const imgs = [...PHOTOS, { src: LIFE }].map(p => '<img src="' + p.src + '" alt="" loading="lazy">').join("");
  $("strip").innerHTML = imgs + imgs;
})();

/* 8–10. Reviews – real data only; sample layout while empty */
const starsHtml = n => '<span class="stars" aria-label="' + n + ' out of 5 stars">' + [1, 2, 3, 4, 5].map(i => '<svg viewBox="0 0 24 24" fill="' + (i <= n ? "currentColor" : "none") + '" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m12 3.6 2.6 5.2 5.7.8-4.1 4 1 5.7-5.2-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8Z"/></svg>').join("") + "</span>";
const checkIcon = '<svg class="check" viewBox="0 0 24 24" fill="currentColor" aria-label="Verified buyer"><path d="M12 2.5l2.4 1.8 3-.2.9 2.9 2.5 1.7-1 2.8 1 2.8-2.5 1.7-.9 2.9-3-.2L12 21.5l-2.4-1.8-3 .2-.9-2.9-2.5-1.7 1-2.8-1-2.8 2.5-1.7.9-2.9 3 .2Z"/><path d="m8.5 12 2.4 2.4 4.6-4.8" fill="none" stroke="#FF7B1C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
(function () {
  const paw = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5a7.5 7.5 0 0 0-7.5 7.5v11l2.5-1.7 2.5 1.7 2.5-1.7 2.5 1.7 2.5-1.7 2.5 1.7V10A7.5 7.5 0 0 0 12 2.5Z"/><ellipse cx="9.4" cy="10.2" rx="1.3" ry="1.8" fill="#F4A6B5"/><ellipse cx="14.6" cy="10.2" rx="1.3" ry="1.8" fill="#F4A6B5"/></svg>';
  const halves = html => "<div style=\"display:flex\">" + html + "</div><div style=\"display:flex\" aria-hidden=\"true\">" + html + "</div>";

  // Orange band: real reviews if you have them, otherwise Halloween lines
  if (CONFIG.reviews.length) {
    const cards = CONFIG.reviews.map(r => '<figure class="rv"><blockquote>“' + esc(r.quote) + '”</blockquote><figcaption>' + (r.verified ? checkIcon : "") + "<span>" + esc(r.name) + "</span>" + starsHtml(r.stars || 5) + "</figcaption></figure>").join("");
    $("reviewTrack").innerHTML = halves(CONFIG.reviews.length < 4 ? cards + cards : cards);
    $("reviews").hidden = false;
  } else if (CONFIG.bandLines.length) {
    const lines = CONFIG.bandLines.map((t, i) => '<span class="rv-line">' + esc(noEmoji(t)) + '</span><span class="rv-sep">' + HICONS[i % 3] + "</span>").join("");
    $("reviewTrack").innerHTML = halves(lines + lines);
    $("reviews").hidden = false;
  }

  // Photo cards: real customer reviews if you have them, otherwise fun captions
  if (CONFIG.spotlight.length) {
    $("spotCards").innerHTML = CONFIG.spotlight.map(c => '<figure class="card"><div class="pic"><img src="' + c.img + '" alt="" loading="lazy"><span class="quote" aria-hidden="true">“</span></div><figcaption>' + starsHtml(c.stars || 5) + "<h3>“" + esc(c.title) + "”</h3><p>“" + esc(c.quote) + '”</p><span class="who">' + esc(c.name) + "</span></figcaption></figure>").join("");
    $("spotlight").hidden = false;
  } else if (CONFIG.photoCaptions.length) {
    $("spotCards").innerHTML = CONFIG.photoCaptions.slice(0, REVIEW_PHOTOS.length).map((c, i) => '<figure class="card caption"><div class="pic"><img src="' + REVIEW_PHOTOS[i] + '" alt="Ghostelle dress: ' + esc(c.title) + '" loading="lazy"><span class="paw">' + paw + "</span></div><figcaption><h3>" + esc(c.title) + "</h3><p>" + esc(c.text) + "</p></figcaption></figure>").join("");
    $("spotlight").hidden = false;
  }
})();
if (CONFIG.socialImages.length) {
  $("socialCards").innerHTML = CONFIG.socialImages.map(u => '<figure class="card"><img src="' + esc(u) + '" alt="Customer post" loading="lazy"></figure>').join("");
  $("social").hidden = false;
}

/* Cart */
let cart = [];
try { cart = JSON.parse(localStorage.getItem("ghostelle-cart") || "[]").filter(l => variantOf(l.size) && l.qty > 0); } catch (e) { cart = []; }
const save = () => { try { localStorage.setItem("ghostelle-cart", JSON.stringify(cart)); } catch (e) {} };
let notice = "";
function add() {
  const picked = sizes.slice(0, bundle);
  if (picked.some(s => !(variantOf(s) || {}).available)) return;
  picked.forEach(s => { const l = cart.find(x => x.size === s); if (l) l.qty = Math.min(MAX, l.qty + 1); else cart.push({ size: s, qty: 1 }); });
  save(); notice = ""; renderCart(); open("drawer");
}
$("addBtn").onclick = add; $("stickyBtn").onclick = add; $("lifeBtn").onclick = add;

function renderCart() {
  const count = cart.reduce((s, l) => s + l.qty, 0);
  $("cartCount").textContent = count; $("cartCount").hidden = !count;
  $("openCart").setAttribute("aria-label", count ? "Open cart, " + count + " items" : "Open cart");
  const body = $("cartBody");
  if (!cart.length) {
    body.innerHTML = '<div class="empty"><svg class="pk-empty" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M11.2 6.2c-.2-1.5.4-2.6 1.7-3.1l.5.9c-.8.4-1.1 1.1-1 2.2ZM12 6.5c-1.3-.6-2.7-.7-4-.3C5.1 7 3 9.6 3 13.4 3 17.8 6.4 21 10 21c.8 0 1.4-.2 2-.4.6.2 1.2.4 2 .4 3.6 0 7-3.2 7-7.6 0-3.8-2.1-6.4-5-7.2-1.3-.4-2.7-.3-4 .3ZM7.6 12.6l1.9-2.4 1.9 2.4ZM12.6 12.6l1.9-2.4 1.9 2.4ZM7.8 15.2c1.3 1.2 2.7 1.8 4.2 1.8s2.9-.6 4.2-1.8l-.8 2.1-1.4-.9-2 1.3-2-1.3-1.4.9Z"/></svg><p>Your cart is empty.</p><button class="cta" type="button" id="emptyBtn">Choose a size</button></div>';
    $("emptyBtn").onclick = () => { close(); $("shop").scrollIntoView({ behavior: "smooth" }); };
    return;
  }
  const pay = PAY ? '<div class="pay">' + PAY + "</div>" : "";
  const subtotal = cart.reduce((s, l) => s + l.qty * variantOf(l.size).price, 0);
  const disc = discountFor(count), total = pctOff(subtotal, disc.off);
  const next = CONFIG.bundles.filter(b => b.off && b.qty > count).sort((x, y) => x.qty - y.qty)[0];
  body.innerHTML = '<ul class="lines">' + cart.map((l, i) =>
    '<li class="line"><img src="' + (PHOTOS[0] ? PHOTOS[0].thumb : "") + '" alt=""><div class="info"><div class="top"><span>' + esc(NAME) + "</span><span>" + money(l.qty * variantOf(l.size).price) + '</span></div><span class="tag">Size ' + l.size + '</span><div class="row"><div class="qty" role="group" aria-label="Quantity, size ' + l.size + '"><button type="button" data-act="dec" data-i="' + i + '" aria-label="Decrease"' + (l.qty <= 1 ? " disabled" : "") + ">−</button><output>" + l.qty + '</output><button type="button" data-act="inc" data-i="' + i + '" aria-label="Increase"' + (l.qty >= MAX ? " disabled" : "") + '>+</button></div><button type="button" class="remove" data-act="rm" data-i="' + i + '">Remove</button></div></div></li>').join("") +
    '</ul><div class="foot"><div class="subtotal"><span>Subtotal</span><span>' + money(subtotal) + "</span></div>" +
    (disc.off ? '<div class="disc"><span>' + esc(disc.tag || "Bundle") + " (−" + disc.off + '%)</span><span>−' + money(subtotal - total) + '</span></div><div class="subtotal total"><span>Total</span><span>' + money(total) + "</span></div>" : "") +
    (next ? '<p class="upsell">Add ' + (next.qty - count) + " more and save " + next.off + "% on your whole order 👻</p>" : "") +
    '<p class="note">Taxes and shipping calculated at checkout.</p>' +
    (notice ? '<p class="notice" role="status">' + notice + "</p>" : "") + '<button class="cta" type="button" id="checkoutBtn">Check out</button>' + pay + "</div>";
  $("checkoutBtn").onclick = checkout;
}
$("cartBody").addEventListener("click", e => {
  const b = e.target.closest("[data-act]"); if (!b) return;
  const i = +b.dataset.i, l = cart[i]; if (!l) return;
  if (b.dataset.act === "inc") l.qty = Math.min(MAX, l.qty + 1);
  if (b.dataset.act === "dec") l.qty = Math.max(1, l.qty - 1);
  if (b.dataset.act === "rm") cart.splice(i, 1);
  save(); notice = ""; renderCart();
});
async function checkout() {
  if (!cart.length) return;

  const VARIANT_IDS = {
    S: 61649611194508,
    M: 61649611227276
  };

  const items = cart.map(item => {
    const size = String(item.size || "").trim().toUpperCase();

    return {
      id: VARIANT_IDS[size],
      quantity: item.qty
    };
  });

  if (items.some(item => !item.id)) {
    notice = "Diese Größe ist momentan nicht verfügbar.";
    renderCart();
    return;
  }

  try {
    const response = await fetch(
      (window.Shopify?.routes?.root || "/") + "cart/add.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: items
        })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      console.error("Shopify Cart Error:", data);
      notice = data.description || "Produkt konnte nicht in den Warenkorb gelegt werden.";
      renderCart();
      return;
    }

    cart = [];
    save();

    window.location.href = "/checkout";
  } catch (error) {
    console.error(error);
    notice = "Fehler beim Öffnen des Checkouts.";
    renderCart();
  }
}

/* Drawers */
const overlay = $("overlay"); let opened = null, lastFocus = null;
function open(id) {
  lastFocus = document.activeElement; opened = $(id);
  opened.classList.add("open"); opened.setAttribute("aria-hidden", "false"); overlay.classList.add("open");
  document.body.style.overflow = "hidden";
  (opened.querySelector(".icon-btn") || opened).focus();
}
function close() {
  if (!opened) return;
  opened.classList.remove("open"); opened.setAttribute("aria-hidden", "true"); overlay.classList.remove("open");
  document.body.style.overflow = ""; opened = null; if (lastFocus) lastFocus.focus();
}
$("openCart").onclick = () => open("drawer"); $("closeCart").onclick = close;
$("openMenu").onclick = () => open("menu"); $("closeMenu").onclick = close;
$("menuLinks").addEventListener("click", e => { if (e.target.closest("a")) close(); });
overlay.onclick = close;
document.addEventListener("keydown", e => { if (e.key === "Escape" && opened) close(); });
document.querySelector('a[href="#info"]') && $("menuLinks").addEventListener("click", e => { if (e.target.getAttribute("href") === "#info") $("info").open = true; });
renderCart();

/* Sticky bar: visible once the main button has scrolled above the screen */
(function () {
  const btn = $("addBtn"), bar = $("sticky"); let ticking = false, shown = false;
  const update = () => {
    ticking = false;
    const show = btn.getBoundingClientRect().bottom < 0;
    if (show === shown) return;
    shown = show; bar.classList.toggle("show", show); bar.setAttribute("aria-hidden", String(!show)); $("stickyBtn").tabIndex = show ? 0 : -1;
  };
  addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  addEventListener("resize", update); update();
})();

if (PAY) { $("payUnder").innerHTML = PAY; $("payUnder").hidden = false; }

/* TikTok Shop link (optional) */
if (CONFIG.tiktokShopUrl) { $("ttShop").href = CONFIG.tiktokShopUrl; $("ttShop").hidden = false; }

/* FAQ */
$("faqList").innerHTML = CONFIG.faq.map(f => '<details><summary>' + esc(f.q) + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></summary><p>' + esc(f.a) + "</p></details>").join("");

/* Size guide (only when a size chart is filled in) */
(function () {
  if (!CONFIG.sizeChart.length) return;
  const cols = Object.keys(CONFIG.sizeChart[0]);
  $("sgTable").innerHTML = "<table><tr>" + cols.map(c => "<th>" + esc(c[0].toUpperCase() + c.slice(1)) + "</th>").join("") + "</tr>" +
    CONFIG.sizeChart.map(r => "<tr>" + cols.map(c => "<td>" + esc(r[c] || "") + "</td>").join("") + "</tr>").join("") + "</table>";
  const dlg = $("sizeGuide"), btn = $("sizeGuideBtn");
  btn.hidden = false;
  const show = on => { dlg.classList.toggle("open", on); dlg.setAttribute("aria-hidden", String(!on)); document.body.style.overflow = on ? "hidden" : ""; if (on) $("sgClose").focus(); else btn.focus(); };
  btn.onclick = () => show(true); $("sgClose").onclick = () => show(false);
  dlg.addEventListener("click", e => { if (e.target === dlg) show(false); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && dlg.classList.contains("open")) show(false); });
})();
